import { compose } from "recompose";
import { connect } from "react-redux";
import { withApp } from "src/components/App/Context";
import { updateUserSuccess } from "src/modules/auth/duck/actions";

import PurchaseFlow from "./PurchaseFlow";

const enhance = compose(
  withApp,
  connect(null, { updateUser: updateUserSuccess })
);
export default enhance(PurchaseFlow);
